<template >
  <div class="container">    
    <div class="card" id="wrapper">
      <h1>EN CONSTRUCCIÓN!</h1>
    </div>
    <br>
  </div>
</template>

<script>


import { debug } from 'util';

export default {
  name: 'Reports',
  data() {
    return {
    };
  },
  created(){
  },
  methods:{
  },
  components: {
  }
}
</script>

<style >

  #wrapper {
    width: 90%;
    margin-left: 5%;
    padding: 70px 30px 70px 30px;
  }

  .dummyframe {
    visibility: hidden;
  }


</style>
